<template>
  <main role="main" class="py-4">
    <div class="container-xxl">
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("customerList") }}</h4>
        <div>
          <!-- <b-button variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button>           -->
          <b-button  v-if="!decreeChoose" variant="outline-success" class="ml-4" :disabled="!totalItems"
            @click="debouncedonClickExportToExcel">
            <b-icon-download class="mr-2"></b-icon-download> {{ $t("export") }}
          </b-button>
          <!-- Button tạo mới tài khoản cho khách hàng với gói cước lưu trữ-->
          <b-button variant="outline-primary" class="ml-4" to="/customers/create-new">
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button>
          <!-- Button tạo mới tài khoản cho khách hàng với gói cước dịch vụ-->
          <!-- <b-button class="mr-4" variant="outline-primary" v-b-modal:new-customer-user-modal>
            <b-icon icon="plus"></b-icon> {{ $t("createNew") }}
          </b-button> -->
        </div>
      </div>

      <b-form class="mb-4" @submit.prevent="onSubmitSearch">
        <div class="d-flex flex-row">
          <div style="width: 90%;" class="d-flex flex-column">

            <div class="d-flex flex-row mb-3 flex-grow-1">
              <div class="d-flex flex-row col-sm-3 flex-grow-1 align-items-center" v-if="isUserAdmin()">
                <div class="flex-shrink-0 mr-2">{{ $t("decree") }}:</div>
                <b-form-select size="md" :options="decreeOptions" v-model="decreeChoose" />
              </div>
              <div class="d-flex flex-row col-sm-4 flex-grow-1 align-items-center">
                <div class="flex-shrink-0 mr-2">{{ $t("keyword") }}:</div>
                <!--Bộ lọc theo ngày tạo tài khoản từ ngày - đến ngày-->
                
                <b-form-input type="search" size="md" :disabled="!!(decreeChoose)" v-model="filterText"
                  :placeholder="$t('customerSearchPlaceholder')" minlength="2" />
                </div>
              <!-- <div class="d-flex flex-row col-sm-4 flex-grow-1 align-items-center">
                 <div class="flex-shrink-0 mr-2">{{ $t("createdTime") }}:</div>
                  <v-datepicker  size="md" style="max-width: 100% !important;"
                      v-model="createdDate" required
                      :range="true" 
                      lang="vi"
                      :show-clear-button="true"
                      inputClass="date-range"
                      :placeholder="$t('selectRangeDate')"
                      @reset=resetCreatedDate()
                  />
                  </div> -->
            </div>

            <b-modal id="bv-modal-example" :title="$t('advancefilter')" class="filter-advanced" hide-footer>
              <div id="filterAdvance">
                <div class="d-flex flex-column">
                  <div class="flex-shrink-0 mb-2">{{ $t("subscriptionStatusFilterSelectLabel") }}:</div>
                  <b-form-select size="md" class=" mb-2" :options="subscriptionPlanStatusOptions"
                    v-model="subscriptionPlanStatus" />
                    <!-- Ngày hiệu lực -->
                  <div class="flex-shrink-0 mb-2">{{ $t("effDate") }}:</div>
                  <date-picker class="mb-2" v-model="effDates" required range format="DD/MM/YYYY" value-type="date"
                    :not-after="new Date()" lang="vi" input-class="form-control" style="width: 100%;"
                    :placeholder="`${$t('fromDate')} - ${$t('toDate')}`" range-separator=" - "
                    @reset=resetEffDate() />

                  <!-- Ngày hết hạn -->
                  <div class="flex-shrink-0 mb-2">{{ $t("expDate") }}:</div>                
                  <date-picker class="mb-2" v-model="expDates" required range format="DD/MM/YYYY" value-type="date"
                  :not-after="new Date()" lang="vi" input-class="form-control" style="width: 100%;"
                  :placeholder="`${$t('fromDate')} - ${$t('toDate')}`" range-separator=" - "
                  @reset=resetEffDate() />
                  <div class="flex-shrink-0 mb-2">{{ $t("areaFilterSelectLabel") }}:</div>
                  <b-form-select class=" mb-2" size="md" :options="areaFilterOptions"
                    v-model="areaFilterSelectedOption" />

                    <!-- chọn văn phòng trực thuộc vnpt -->
                      <!-- <template>
                        <div>
                          <div class="flex-shrink-0 mb-2">Chọn đơn vị:</div>
                          <VueTreeselect class="mb-2"
                            v-model="companySelected"
                            :options="companyOptions"
                            :normalizer="normalizer"
                            :placeholder="$t('vnptGroup')"
                            :clearable="true"
                            :searchable="true"
                            :disable-branch-nodes="true"
                            :default-expand-level="1"
                          />
                        </div>
                      </template> -->
                  <div class="flex-shrink-0  mb-2">{{ $t("subscriptionPlan") }}:</div>
                  <div class="multi-selection">
                    <v-multiselect class="mb-2" v-model="subscriptionPlanFilterSelectedOption"
                      :placeholder='$t("chooseSubscription")' label="text" track-by="value"
                      :options="subscriptionPlanFilterOptions" :multiple="true" :show-labels="false"
                      :hide-selected="false" :close-on-select="false" :clear-on-select="false" :searchable="true"
                      :limit="0" :limitText="limitText" @select="onSelectPlan" @open="isOpen = true"
                      @close="isOpen = false" :preserve-search="true" :preselect-first="true">
                      <span slot="noResult">{{ $t("noFoundSearch") }}</span>
                    </v-multiselect>
                  </div>
                  <!-- chọn loại chức năng của khách hàng -->
                      <template>
                        <div>
                          <div class="flex-shrink-0 mb-2">Tích hợp:</div>
                          <b-form-select
                            class="mb-2"
                            v-model="featureTypeSelected"
                            :options="featureOptions"
                          />
                        </div>
                      </template>
                 
                  <!-- <div class="flex-shrink-0 mb-2">{{ $t("customerType") }}:</div>
                  <b-form-select class="mb-2" size="md" :options="customerTypeOptions" v-model="customerTypeOption" />
                     <div class="flex-shrink-0 mb-2">{{ $t("customerSource") }}:</div>
                  <b-form-select class="mb-2" size="md" :options="customerSourceOptions" v-model="customerSourceOption" /> -->
                  <!-- <div v-if="isVnpt()">
                    <div class="flex-shrink-0 mb-2">{{ $t("underTheUnit") }}:</div>
                    <b-form-select size="md" :options="coTypesOptions" v-model="coType" />
                  </div>
                  <div v-if="isOutside()">
                    <div class="flex-shrink-0 mb-2">{{ $t("ownedBy") }}:</div>
                    <b-form-select size="md" :options="idTypesOptions" v-model="idType" />
                  </div> -->
                  <div class="d-flex flex-row" style="justify-content: space-between; margin-top: 10px">
                    <b-button @click="clearFilter" style="width: 49%" size="md" class="flex-shrink-0"
                      variant="outline-secondary">{{ $t("clearFilter") }}</b-button>
                    <b-button @click="submitFilter" style="width: 49%" size="md" class="flex-shrink-0"
                      variant="primary">{{ $t("apply") }}</b-button>
                  </div>
                </div>
              </div>
            </b-modal>
          </div>

          <div style="margin-left: 1em; align-items: center; justify-content: flex-end;"
            class="d-flex flex-row mb-3 flex-grow-1">
            <b-button @click="showFilter" variant="primary" style="margin-right: 1px;
              padding: 6px; margin-left: 5px;" :title="$t('')" :disabled="!!(decreeChoose)">
            <b-icon-funnel /></b-button>
            <b-button type="submit" size="md" class="flex-shrink-0 ml-1" variant="primary">{{
            $t("search") }}</b-button>
          </div>
        </div>
      </b-form>

      <b-table id="tblKhachHang" ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields"
        :busy="isLoading" show-empty :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-if="!disabledAction" v-slot:cell(name)="data">
          <router-link :to="'/customers/details/' + data.item.id">{{ data.item.name }}</router-link>
          <br>
          <span class="fs-14">{{ data.item.email }}</span>
          <br>
          <span class="fs-14">{{ data.item.phoneNumber }}</span>
        </template>
     <template v-if="!disabledAction" v-slot:cell(totalMeetings)="data">
        
          <span class="fs-14">{{ $t("datao")+" : "+    data.item.totalMeetings }}</span>
          <br>
          <span class="fs-14">{{ $t("hoanthanh") +" : "+  data.item.totalMeetingsEnded }}</span>
                <br>
          <span class="fs-14">{{ $t("daxoa") +" : "+    data.item.totalMeetingsDeleted }}</span>
                       <br>
          <span class="fs-14">{{ $t("dahuy") +" : "+    data.item.totalMeetingsCancelled }}</span>
        </template>
        <template v-if="!disabledAction" v-slot:cell(actions)="data">
          <!--<router-link :to="'/customers/details/' + data.item.id">{{ $t("details") }}</router-link>-->
          <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none p-0" no-caret right
            menu-class="shadow">
            <template v-slot:button-content>
              <b-icon icon="three-dots" />
            </template>
            <b-dropdown-item :to="'/customers/details/' + data.item.id">{{ $t("details") }}</b-dropdown-item>
            <b-dropdown-item :to="`/customers/details/${data.item.id}/subscription`">{{ $t("manageServices")
            }} </b-dropdown-item>
            <b-dropdown-item v-if="isManager()" :to="'/customers/edit/' + data.item.id">{{ $t("updateInfo")
            }}</b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="d-flex flex-row justify-content-end">
        <div class="d-flex flex-row align-items-center">
          <div v-if="totalItems" class="text-right flex-shrink-0 mr-3">{{ $t("resultCount", { count: totalItems }) }}
          </div>
          <b-pagination class="my-0 mr-3" v-model="currentPage" :total-rows="totalItems"
            :per-page="itemsPerPage"></b-pagination>
          <b-form-select v-model="itemsPerPage" :options="itemsPerPageSelections"></b-form-select>
        </div>
      </div>

    </div>
    <b-modal id="new-customer-user-modal" :title="$t('createCustomerUserAccount')" dialog-class="min-width-700"
      hide-footer no-close-on-backdrop>
      <new-customer-user-modal @submitted="refreshData" />
    </b-modal>
  </main>
</template>

<style lang="scss">
.multiselect__tag {
  color: white;
  background-color: #004f9e !important;
  font-size: 1rem;
}

.multiselect .multiselect__content-wrapper {
  min-width: 200px !important;
  width: auto;
  border: none;
  box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, .1);
}

.date-range {
  height: 38px !important;
}

.multiselect__tag-icon:after {
  content: "×";
  color: white !important;
  font-size: 14px;
}

.multiselect__tag {
  height: 31px !important;
  position: relative;
  display: inline-block;
  padding: 0.25rem 1.625rem 0.25rem 0.625rem;
  margin-right: 0.625rem;
  line-height: 1;
  margin-bottom: 0.5rem;

  .multiselect__placeholder {
    font-size: 14px;
  }

  .multiselect__tag-icon {
    background: #004f9e;

    i {
      color: white;
    }

    &:hover {
      background-color: #004f9e !important;
    }
  }

  span {
    font-size: 14px;
  }
}

.multiselect__option--disabled {
  background: purple;
  color: rgba(var(--vs-primary), 1);
  font-style: italic;
}

.multiselect__option--highlight {
  background-color: #4993dd !important;
  color: white;
  font-size: 0.9rem;
  height: 1rem;
}

.multiselect__option {

  .multiselect__option--highlight {
    background: #4993dd !important;
    color: #fff
  }

  &:after {
    background: #4993dd !important;
  }
}

.multiselect__single {
  display: none;
}

.custom-multiselect .multiselect__content-wrapper {
  width: 200px !important;
}

.custom-multiselect .multiselect__option {
  padding: 5px !important;
  font-size: 14px !important;
}

.filter-advanced {
  position: absolute;
  z-index: 1000;
  width: 360px;
  // margin-top: 55px;
  right: 25%;
  /* transform: translate3d(0px, 41px, 0px); */
  /* border: 1px solid black; */
  border-radius: 5px;
  padding: 20px;
  background: white;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  // overflow: auto;
}

.fs-14 {
  font-size: 14px !important;
}
.vue-treeselect__option:hover {
  background-color: #004f9e !important;
  color: #fff !important;
}

/* Khi item đang được focus (ví dụ dùng phím mũi tên) */
.vue-treeselect__option--highlight {
  background-color: #004f9e !important;
  color: #fff !important;
}
.multiselect__tags{
  min-height: 38px !important;  
  height: 38px !important;
  padding: 5px 40px 0 8px !important;
}
</style>

<script lang="ts">
import { Component, Ref, Vue } from 'vue-property-decorator';
import _ from "lodash";
import BaseComponent from "@/components/BaseComponent";
import { BvTableFieldArray } from "bootstrap-vue";
import { BTable, BvTableCtxObject, BvTableProviderPromiseResult } from "bootstrap-vue/src/components/table";
import * as areaService from "@/service/areaService";
import * as subscriptionPlanService from "@/service/subscriptionPlanService";
import * as customerService from "@/service/customerService";
import { BounceTimes } from "@/views/enums/TimesNumbers";
import * as exportService from "@/service/exportService";

import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import VueTreeselect from '@riophae/vue-treeselect';

import {enumIntegrate} from '@/views/enums/enumIntegrate';
import { formatDateRangeWithoutZ } from '@/service/util';
import { SearchRequestManager } from "@/utils/search-request-manager";

@Component({
  components: {
    DatePicker, VueTreeselect
  },
})
export default class CustomerList extends BaseComponent {
  isOpen = false;
  datePickerFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' };

  startDate: Date = null;
  endDate: Date = null;
  expStartDate: Date = null;
  expEndDate: Date = null;
  customerListRes = [];
  effDates: Date[] = [];
  expDates: Date[] = [];
  createdDate: Date[] = [];
  filterText = "";

  areaFilterSelectedOption: number = null;
  areaFilterOptions = [];

  subscriptionPlanFilterSelectedOption: any[] = [];
  subscriptionPlanFilterOptions = [];

  subscriptionPlanStatus = "all";
  subscriptionPlanStatusOptions = [
    { value: "all", text: this.$t("all").toString() },
    { value: "using", text: this.$t("unexpired").toString() },
    { value: "near_expire", text: this.$t("nearExpired").toString() },
    { value: "expired", text: this.$t("expired").toString() },
  ];
  customerSourceOptions =  [
        { value: null, text: 'Tất cả' },
        { value: 'ONESME', text: 'ONESME' },
        { value: 'VNEDU', text: 'VNEDU' },
        { value: 'VNPT', text: 'VNPT' },
        { value: 'VNPT_IT', text: 'VNPT IT' },
        { value: 'GOOGLE', text: 'GOOGLE' },
        { value: 'USER_PASS', text: 'USER PASS' },
        { value: 'ONEBSS', text: 'ONEBSS' },
        
  ];
  customerSourceOption = null;
  customerTypeOption = null;
  coType = null;
  coTypesOptions = [
    // {value:  null, text: this.$t("all").toString()},
    { value: "vinaphone", text: this.$t("vinaphone").toString() },
    { value: "media", text: this.$t("media").toString() },
    { value: "net", text: this.$t("net").toString() },
    { value: "vt_ttp", text: this.$t("vt_ttp").toString() },
    { value: "tdagency", text: this.$t("tdagency").toString() },
    { value: "it", text: this.$t("it").toString() },
    { value: "other", text: this.$t("other").toString() }
  ];

  idType = null;
  idTypesOptions = [
    // {value:  null, text: this.$t("all").toString()},
    { value: "personal", text: this.$t("personal").toString() },
    { value: "business", text: this.$t("business").toString() },
    { value: "organ", text: this.$t("organ").toString() },
    { value: "other", text: this.$t("other").toString() },
  ];


  customerTypeOptions = [
    { value: null, text: this.$t("all").toString() },
    {
      label: this.$t("invnpt").toString(),
      options: this.coTypesOptions
    },
    {
      label: this.$t("outside").toString(),
      options: this.idTypesOptions
    },
  ];
  featureTypeSelected = null;
  featureOptions = [ 
    { value: enumIntegrate.NONE, text: `-- Chọn chức năng --` },
    { value: enumIntegrate.ALLOW_SUMMARY, text: this.$t("meetingSumary").toString() },
    { value: enumIntegrate.ACTIVE_GM_TOKEN, text: this.$t("activeGMToken").toString() },
    { value: enumIntegrate.BOTH, 
    text: `${this.$t("meetingSumary")} ${this.$t("and")} ${this.$t("activeGMToken")}`},
  ];

  isLoading = false;
  areas = [];
  subscriptionPlans = [];

  itemsPerPageSelections = [
    { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
    { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
    { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
    { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
  ];
  itemsPerPage = 20;
  currentPage = 1;
  totalItems = 0;
  searchManager = new SearchRequestManager();
  decreeOptions = [
    { value: 0, text: this.$t("agree").toString() },
    { value: 1, text: this.$t("disagree").toString() }
  ];
  decreeChoose = 0;
  disabledAction = 0;
  decreeChange(checked) {
    this.decreeChoose = checked ? 0 : 1;
  }

  showFilter() {
    this.$bvModal.show('bv-modal-example');
  }

  resetEffDate() {
    this.effDates = [];
  }
  refreshData() {
    this.table.refresh();
  }
  resetExpDate() {
    this.expDates = [];
  }
  resetCreatedDate() {
    this.createdDate = [];
  }

  @Ref("table") table: BTable;
  tableFields: BvTableFieldArray = [
    {
      key: "id",
      label: "ID",
      thClass: "text-nowrap",
    },
    {
      key: "customerCode",
      label: this.$t("customerIdShort").toString(),
      thClass: "text-nowrap",
    },
    {
      key: "name",
      label: this.$t("customerNameShort").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "totalMeetings",
      label: this.$t("tongsocuochop").toString(),
      tdClass: "text-break", 
    }
  ];

  extraFields: BvTableFieldArray = [
    {
      key: "saleAreaName",
      label: this.$t("saleArea").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
      thStyle: { width: '150px' }
    },
    {
      key: "subPlanName",
      label: this.$t("subscriptionPlan").toString(),
      thClass: "text-nowrap",
      tdClass: "text-break",
    },
    {
      key: "cusSubEndDate",
      formatter: this.formatter,
      label: this.$t("expDate").toString(),
      thClass: "text-nowrap",
    }  
  ];

  extraKeys = ['saleAreaName', 'subPlanName', 'cusSubEndDate', 'createdTime', 'remainingDays'];
  countFil = 0;
  companySelected = null;
  companies = [];

  mounted() {
    this.tableFields = this.tableFields.concat(this.extraFields);
    if (this.isManager()) {
      // _.remove(this.tableFields, it => it["key"] === "saleAreaName");
      this.tableFields = this.tableFields.filter(it => it["key"] !== "saleAreaName");
    }
    const index = this.isManager() ? 7 : this.isUserSuperAdmin() ? 8 : -1;

    index !== -1 && this.tableFields.splice(index, 0, {
      key: "remainingDays",
      label: this.$t("remainingDays").toString()
    });

    this.initialLoad();
    this.areaFilterSelectedOption = this.getUserManagerSaleAreaId() || null;
    this.extraFields.push({
      key: "actions",
      label: "",
      thClass: "text-nowrap",
    },);
  }
  /**
   * Chuẩn hóa dữ liệu JSON thành cấu trúc treeselect hiểu được
   * - id -> id
   * - name -> label
   * - children -> children
   */
  normalizer(node) {
    return {
      id: node.id,
      label: node.name,
      children: node.children
    };
  }

  formatter(value, key, index) {
    value = new Date(value);
    return value.getFullYear() > 10 ? value.toLocaleDateString('en-GB') : null;
  }

  decreeFormat(value) {
    return this.disabledAction ? "xxxxxxxx" : value;
  }

  async initialLoad() {
    try {
      this.isLoading = true;

      const fetchAreasPromise = areaService.getAll();
      const fetchSubscriptionPlansPromise = subscriptionPlanService.getPlans();

      this.areas = await fetchAreasPromise;
      this.areaFilterOptions = this.areas.map(it => ({ value: it.id, text: it.name }));
      this.areaFilterOptions.unshift({ value: null, text: this.$t("all").toString() });

      this.subscriptionPlans = await fetchSubscriptionPlansPromise;
      this.subscriptionPlanFilterOptions = this.subscriptionPlans.map(it => ({ value: it.id, text: it.name }));
      this.subscriptionPlanFilterOptions.unshift({ value: null, text: this.$t("all").toString() });

    } catch (e) {
      this.toastError(e);
    } finally {
      this.isLoading = false;
    }
  }

  limitText(count) {
    return this.$t("countPackage", { count });
  }

  onSelectPlan(option) {
    if (option.value == null)
      this.subscriptionPlanFilterSelectedOption = [];
  }

  isVnpt() {
    return this.customerTypeOption == "invnpt";
  }

  isOutside() {
    return this.customerTypeOption == "outside";
  }

  async onClickReloadBtn() {
    this.filterText = "";
    this.areaFilterSelectedOption = null;
    this.subscriptionPlanFilterSelectedOption = [];
    this.subscriptionPlanStatus = "all";
    this.featureTypeSelected = null;
    this.startDate = null;
    this.endDate = null;
    this.expStartDate = null;
    this.expEndDate = null;
    this.customerTypeOption = null;
    this.coType = null;
    this.idType = null;
    this.effDates = [];
    this.expDates = [];
    this.currentPage = 1;
    await this.initialLoad();
    this.table.refresh();
  }

  async clearFilter() {
    this.onClickReloadBtn();
    this.$bvModal.hide('bv-modal-example');
  }

  onSubmitSearch() {
    this.searchManager.onSubmit({
      debounceFn: this.debouncedonFilterFormSubmit,
      resetPage: () => { this.currentPage = 1; },
      execute: () => { this.table.refresh(); }
    });
  }

  onFilterFormSubmit() {
    this.currentPage = 1;
    this.table.refresh();
  }

  submitFilter() {
    this.onFilterFormSubmit();
    this.$bvModal.hide('bv-modal-example');
  }

  async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
    const currentRequestId = this.searchManager.nextId();
    try {
      let cusType = null;
      if (this.customerTypeOption) {
        cusType = this.idTypesOptions.map((option) => option.value).includes(this.customerTypeOption) ? "outside" : "invnpt";
      }
      const response = await customerService.getCustomers({
        page: ctx.currentPage,
        pageSize: this.itemsPerPage,
        // Tìm kiếm theo ngày tạo
        createdTimeStart: formatDateRangeWithoutZ(this.createdDate?.[0]),
        createdTimeEnd: formatDateRangeWithoutZ(this.createdDate?.[1]),
        q: this.filterText?.trim(),
        areaId: this.areaFilterSelectedOption,
        subscriptionPlanId: this.subscriptionPlanFilterSelectedOption.length > 0 ? this.subscriptionPlanFilterSelectedOption.map(it => it.value): null,
        subscriptionPlanStatus: this.subscriptionPlanStatus,
        featureType: this.featureTypeSelected,
        // Tìm kiếm theo ngày hiệu lực (EffDates)
        dateStart: formatDateRangeWithoutZ(this.effDates?.[0]),
        dateEnd: formatDateRangeWithoutZ(this.effDates?.[1]),
        // Tìm kiếm theo ngày hết hạn (ExpDates)
        dateExpStart: formatDateRangeWithoutZ(this.expDates?.[0]),
        dateExpEnd: formatDateRangeWithoutZ(this.expDates?.[1]),
        customerType: this.customerTypeOption ? cusType : null,
        customerSource: this.customerSourceOption,
        idType: cusType === "outside" ? this.customerTypeOption : null,
        coType: cusType === "invnpt" ? this.customerTypeOption : null,
        isDeleted: this.decreeChoose
      });
      if (!this.searchManager.isLatest(currentRequestId)) {
        return this.customerListRes || [];
      }
      this.customerListRes = response.data;
      this.totalItems = response.total;
      this.disabledAction = this.decreeChoose;
      if (this.disabledAction) {
        // _.remove(this.tableFields, it => this.extraKeys.includes(it["key"]));
        this.tableFields = this.tableFields.filter(it => this.extraKeys.includes(it["key"]));
        this.tableFields.push({
          key: "deletedTime",
          formatter: this.formatter,
          label: this.$t("deleteDate").toString(),
          thClass: "text-nowrap",
        });
      }
      else {
        // _.remove(this.tableFields, it => it["key"] === "deletedTime");
        this.tableFields = this.tableFields.filter(it => it["key"] !== "deletedTime");
        this.tableFields = this.tableFields.concat(this.extraFields);
      }
      return this.customerListRes;

    } catch (e) {
      if (this.searchManager.isLatest(currentRequestId)) {
        this.toastError(e);
      }
      return [];
    }
  }
  //Kiểm tra và make sure không cho bấm 1 lúc quá nhiều lần  - cho nút xuất file excel

  debouncedonFilterFormSubmit   = _.debounce(() => {
    this.onFilterFormSubmit ();
  }, BounceTimes.BOUNCETIMES);
  debouncedonClickExportToExcel = _.debounce(() => {
    this.onClickExportToExcel();
  }, BounceTimes.BOUNCETIMES);
  async onClickExportToExcel(): Promise<any> {
      try {
        /// Dùng arrow function wrapper
        await exportService.exportCustomerListExcel(
          this.customerListRes,
          (key: string) => this.$t(key) as string
        );
    } catch (e) {
      this.toastError(e);
      return [];
    }
    }
}
</script>
